"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setStorageAtKey = exports.setRawStorage = void 0;
const parachain_1 = require("../parachain");
const encoding_1 = require("./encoding");
function setRawStorage(api, key, value, account, isLittleEndian = true) {
    return __awaiter(this, void 0, void 0, function* () {
        yield setStorageAtKey(api, key, value.toHex(isLittleEndian), account);
    });
}
exports.setRawStorage = setRawStorage;
function setStorageAtKey(api, key, data, sudoAccount) {
    return __awaiter(this, void 0, void 0, function* () {
        const tx = api.tx.sudo.sudo(api.tx.system.setStorage([[key, data]]));
        const inBlockExtrinsicStatus = (0, encoding_1.newExtrinsicStatus)(api, "InBlock");
        yield parachain_1.DefaultTransactionAPI.sendLogged(api, sudoAccount, tx, undefined, inBlockExtrinsicStatus);
    });
}
exports.setStorageAtKey = setStorageAtKey;
//# sourceMappingURL=storage.js.map